export default function Footer() {
  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { label: '最新快讯', href: '#updates' },
        { label: '焦点专题', href: '#carousel' },
        { label: '热门爆料', href: '#cards' },
        { label: '吃瓜排行', href: '#ranking' },
        { label: '视频专区', href: '#media' },
      ],
    },
    {
      title: '平台服务',
      links: [
        { label: '联系我们', href: '#contact' },
        { label: '关于我们', href: '#about' },
        { label: '常见问题', href: '#faq' },
        { label: '客户端下载', href: '#app' },
        { label: '主题索引', href: '#index' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
      isPartner: true,
    },
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <span className="text-lg font-heading font-bold text-primary-500 mb-4 block">51黑料</span>
            <p className="text-sm text-foreground-500 leading-relaxed">
              51黑料网 - 国内领先的娱乐资讯聚合平台。51黑料网站提供最新最热的吃瓜入口与黑料网入口，51黑料官网地址一键直达，51黑料网页版随时随地畅享精彩内容。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#hero" onClick={(e) => handleClick(e, '#hero')} className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 hover:bg-primary-200 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => handleClick(e, '#hero')} className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 hover:bg-primary-200 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => handleClick(e, '#hero')} className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 hover:bg-primary-200 transition-colors cursor-pointer">
                <i className="ri-video-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4">{group.title}</h4>
              {group.isPartner ? (
                <p className="text-sm text-foreground-400">合作伙伴招募中</p>
              ) : (
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => handleClick(e, link.href)}
                        className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/70 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 51黑料 - 51黑料网 版权所有
          </p>
          <p className="text-xs text-foreground-400">
            51黑料官网入口地址 · 51黑料网页版登录直达
          </p>
        </div>
      </div>
    </footer>
  );
}